import _ from "lodash";
import {
  AuthorizationFailedReason,
  IncidentType
} from "@moderrotech/servers-communication-library/src/types";

export const he = {
  topics: {
    headerTitle: "נושאי פנייה",
    search: "חיפוש",
    noTopics: "לא נמצאו נושאים",
    notFound: "לא נמצאו נושאים התואמים את החיפוש",
    schedule: {
      closed: "השירות לא זמין כעת"
    },
    customerInfoForm: {
      title: "לפני שנתחיל בשיחת הווידאו שלך...",
      description:
        "לפני השימוש בבנקאות וידאו ליישום ההלוואה שלך, אנא מלא את הטופס",
      optional: "אופציונאלי",
      buttons: {
        cancel: "לְבַטֵל",
        submit: "התחל שיחת וידאו"
      }
    }
  },
  call: {
    calling: "יִעוּד...",
    joining: "מצטרף לשיחה",
    transferring: "השיחה מועברת",
    aspectRatio: "תקריב",
    cancel: "ביטול שיחה",
    end: "ניתוק שיחה",
    share: "שיחה רב צדדית",
    document: "קובץ",
    actions: "פעולות",
    closeActions: "ביטול",
    mute: "השתקה",
    unmute: "ביטול השתקה",
    textMessage: "הודעת טקסט",
    queuePosition: (ctx: { list: Function }) => {
      const position = ctx.list(0);
      const isPositionAvailable = ctx.list(1);
      return isPositionAvailable
        ? _.reverse(["בתור", position, "מיקומך"]).join(" ")
        : "מיקומך בתור";
    },
    ticket: "פנייה",
    camera: {
      enable: "הפעלת מצלמה",
      disable: "הפסקת מצלמה"
    },
    hangupRequest: {
      title: "?בטוח",
      body: "?לנתק את השיחה",
      yes: "כן, לנתק",
      no: "לא, להישאר בשיחה"
    },
    downloadFileRequest: {
      title: "נציג שיתף איתך קובץ",
      yes: "להורדת הקובץ",
      no: "לביטול"
    },
    openUrlRequest: {
      title: "פתיחת קישור",
      body: "הנציג רוצה לפתוח את הקישור בלשונית נפרדת",
      yes: "לפתוח קישור",
      no: "לביטול"
    },
    lowPerformanceNotification: {
      title:
        "נראה שהמכשיר שלך איטי, יש לסגור את המצלמה כדי להמנע מאיטיות בשיחה",
      gotIt: "הבנתי"
    },
    signaturePad: {
      submit: "שליחה",
      clear: "מחיקה",
      cancel: "ביטול"
    },
    paintover: {
      submit: "שליחה",
      clear: "מחיקה",
      cancel: "ביטול"
    },
    textMessageForm: {
      placeholder: "הוֹדָעָה"
    },
    recordTranslator: {
      transcribing: "תדבר בבקשה"
    },
    cameraSnapshot: {
      title: "תמונת מצב של מצלמה"
    },
    mediaInputsAccessNote: {
      title: "אנא אפשר גישה למיקרופון ולמצלמה",
      description: "חפש חלון קופץ קטן ליד שורת הכתובת של הדפדפן שלך."
    },
    animatedCharacter: {
      listening: {
        title: "הנציג מקשיב",
        description: "אפשר לדבר עכשיו. אמור את השאלה או הבקשה שלך."
      },
      thinking: {
        title: "הנציג חושב",
        description: "אנא המתן בזמן שהנציג מחפש תשובה."
      }
    },
    success: {
      document: "הקובץ נשלח בהצלחה",
      feedback: "הפידבק נשלח",
      textMessage: "הודעת הטקסט נשלחה",
      signaturePad: "החתימה נשלחה",
      paintover: "התמונה נשלחה",
      textCopy: "הטקסט הועתק",
      imageCopy: "התמונה הועתקה ללוח",
      callSharing: "הקישור הועתק ללוח"
    },
    error: {
      base: "משהו השתבש. טען מחדש את העמוד בבקשה",
      mediaInputsAccess:
        "לא ניתן לקבל גישה למיקרופון ו/או למצלמה. אנא הפעל אותם בהגדרות",
      join: "לא ניתן להצטרף לשיחה",
      document: "לא ניתן לשלוח את הקובץ",
      noExperts: "אין נציגים זמינים",
      noTopic: "נושא הפנייה כבר לא זמין",
      queueSuspended:
        "התור הושעה<br>איננו יכולים לקבל שיחות חדשות כרגע. אנא נסה שוב מאוחר יותר.",
      queueOverloaded:
        "התור עמוס יתר על המידה<br>אנו חווים כמות גדולה של שיחות. אנא נסה שוב מאוחר יותר.",
      timeout: "לנציג לוקח יותר מדי זמן לעלות לשיחה",
      documentSize: "הקובץ גדול מדי",
      feedback: "משהו השתבש",
      noRoom: "מועד הפגישה פג או בוטל",
      textMessage: "לא ניתן לשלוח את הודעת הטקסט",
      signaturePad: "לא ניתן לשלוח את החתימה",
      paintover: "שגיאת שליחת התמונה",
      textCopy: "לא ניתן להעתיק את הטקסט",
      imageCopy: "לא ניתן להעתיק תמונה",
      callSharing: "לא ניתן לשתף קישור",
      recordTranslation: {
        play: "לא ניתן להשמיע אודיו לתרגום",
        streamGetting: "לא ניתן להשיג זרם אודיו",
        transcription: "לא ניתן לתמלל את הרשומה",
        translation: "לא ניתן לתרגם את הרשומה",
        unsupportedLanguage:
          "נבחרה לא נתמכת עבור שפת תרגום האודיו שלך. אבל ניתן לתרגם את האודיו של המומחה בשפה זו"
      },
      geolocation: "לא ניתן לקבל מיקום גיאוגרפי",
      cameraSnapshot: "לא ניתן לצלם תמונת מצב של המצלמה"
    },
    onHold: {
      title: "בהמתנה",
      description: "הנציג כבר יהיה איתך"
    },
    remoteActionRequest: {
      shareFile: {
        title: ["הנציג רוצה לשתף קובץ מהמכשיר שלך. להסכים", "?"].join(""),
        yes: "כן",
        no: "לא"
      },
      screenSharing: {
        title: ["המומחה רוצה לראות את המסך שלך. להתיר", "?"].join(""),
        yes: "כן",
        no: "לא"
      }
    },
    settings: {
      title: "הגדרות",
      labels: {
        camera: "מצלמה",
        microphone: "מיקרופון"
      }
    }
  },
  thank: {
    toTopics: "בחזרה לנושאים",
    redirect: "למועד שנקבע מראש"
  },
  ticket: {
    creationRequest: {
      title: (ctx: { list: Function }) => {
        const incidentType = ctx.list(0);
        return incidentType === IncidentType.queueTimeout
          ? "נגמר הזמן."
          : "אין מומחים זמינים לענות לשיחתך.";
      },
      body:
        "אתה יכול להשאיר הודעה לסוכנים שלך כדי שיוכלו ליצור איתך קשר ברגע שהם יהיו זמינים",
      yes: "צור כרטיס",
      no: "לא תודה"
    },
    form: {
      labels: {
        phone: "טלפון",
        email: "אימייל",
        message: "הוֹדָעָה"
      },
      buttons: {
        cancel: "לְבַטֵל",
        submit: "שלח הודעה"
      }
    }
  },
  feedback: {
    form: {
      fields: {
        email: {
          label: "מִן:",
          validation: {
            label: "אֶלֶקטרוֹנִי"
          }
        },
        message: {
          label: "הוֹדָעָה",
          placeholder: "הוֹדָעָה",
          validation: {
            label: "הוֹדָעָה"
          }
        }
      },
      buttons: {
        submit: "לִשְׁלוֹחַ",
        cancel: "לְבַטֵל",
        open: "הוסף הודעת משוב..."
      },
      notifications: {
        success: "דוח באג נשלח"
      }
    }
  },
  error: {
    connection: {
      title: (ctx: { list: Function }) => {
        const isOnCall = ctx.list(0);
        return isOnCall
          ? "הנציג עדיין איתך וכבר ישוב לשיחה"
          : "השירות אינו זמין באופן זמני";
      },
      description: (ctx: { list: Function }) => {
        const isOnCall = ctx.list(0);
        return isOnCall
          ? "כבר מחברים אותך בחזרה"
          : "החיבור אבד. מתחבר מחדש...ש";
      },
      code: "קוד: 503"
    },
    login: {
      credentials: "שם משתמש או סיסמה שגויים",
      default: "משהו לא עובד לנו"
    },
    unpublished: {
      title: "האפליקציה לא קיימת.",
      description: "ייתכן שהפרסום בוטל זמנית או נמחק לצמיתות.",
      code: "קוד: 404"
    },
    authorization: {
      title: "הגישה אסורה",
      description: (ctx: { list: Function }) => {
        const reason = ctx.list(0) as
          | AuthorizationFailedReason.geofencingFailed
          | AuthorizationFailedReason.noLicense
          | AuthorizationFailedReason.remStopped
          | AuthorizationFailedReason.noPtpcResponse;
        return {
          [AuthorizationFailedReason.geofencingFailed]:
            "היישום אינו זמין במדינה או באזור שלך.",
          [AuthorizationFailedReason.noLicense]: "אין רישיון מוקצה.",
          [AuthorizationFailedReason.remStopped]: "השירות אינו זמין.",
          [AuthorizationFailedReason.noPtpcResponse]: "אין תגובת שרת."
        }[reason];
      },
      code: "קוד: 403"
    },
    network: {
      title: "אנא ודא שיש לך גישה לאינטרנט"
    }
  },
  validation: {
    phone: "השדה {field} חייב להיות מספר טלפון חוקי",
    dni: "מזהה שגוי, פורמט לא חוקי",
    nie: "מזהה שגוי, פורמט לא חוקי"
  }
};
